// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oRcb","largestCol":"styles_largestCol__1cwUY","smallestCol":"styles_smallestCol__11Rh9"};